import React from 'react'
import { IonGrid, IonRow } from '@ionic/react'
import strings from '../../../strings'
import { Text } from '@mytours/components'

import './styles/loader.less'

const Loader: React.FC = () => (
	<IonGrid className="loader-container">
		<IonRow className="spinner-row">
			<i className="fal fa-spinner fa-spin" />
		</IonRow>
		<IonRow>
			<Text variant="inherit" aria-live="assertive">
				{strings.loading}
			</Text>
		</IonRow>
	</IonGrid>
)

export default Loader
